import { motion } from 'framer-motion';

export function ChatBubbleLoader() {

  // Use a more reliable color - rgba for better compatibility
  const dotColor = 'rgba(52, 208, 148, 0.5)';

  return (
    <motion.div
      className="w-[30px] h-[15px] my-2"
      style={{
        background: `
          radial-gradient(farthest-side, ${dotColor} 90%, transparent) 0% 50%,
          radial-gradient(farthest-side, ${dotColor} 90%, transparent) 50% 50%,
          radial-gradient(farthest-side, ${dotColor} 90%, transparent) 50% 50%,
          radial-gradient(farthest-side, ${dotColor} 90%, transparent) 100% 50%
        `,
        backgroundSize: '25% 50%',
        backgroundRepeat: 'no-repeat'
      }}
      animate={{
        backgroundPosition: [
          '0% 50%, 50% 50%, 50% 50%, 100% 50%',
          '0% 0%, 50% 100%, 50% 100%, 100% 0%',
          '50% 0%, 0% 100%, 100% 100%, 50% 0%',
          '50% 50%, 0% 50%, 100% 50%, 50% 50%'
        ]
      }}
      transition={{
        duration: 1,
        repeat: Infinity,
        ease: 'linear',
        times: [0, 0.33, 0.66, 1]
      }}
    />
  );
}
